import React from 'react';
import { Box, Text, Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { dataHooks } from '../../datahooks';
import { useStoreNameData } from '../../context/storeNameAtoms';
import { useStorePayments } from '../../hooks/useStorePayments';
import { useStoreLaunch } from '../../hooks/useStoreLaunch';
import { AcceptTerms } from '../../components/AcceptPayments/AcceptTerms';
import { CardLayout } from '../../../../components/layouts/CardLayout';
import { ChevronRight } from 'wix-ui-icons-common';

export function StoreNameSide() {
  const { t } = useTranslation();
  const storeNameData = useStoreNameData();
  const { handleAcceptPaymentsChange } = useStorePayments();
  const { launchStore } = useStoreLaunch();

  const { isAcceptedPayments, currentStoreName, isShowAcceptPayments } = storeNameData;

  return (
    <Box direction="vertical" gap={4} dataHook={dataHooks.StoreNameSideContent}>
      <CardLayout>
        <AcceptTerms
          onCheckboxChange={handleAcceptPaymentsChange}
          isAccepted={isAcceptedPayments}
          isShowPayments={isShowAcceptPayments}
        />
      </CardLayout>

      <CardLayout gap={3}>
        <Text weight="bold">{t('store_name.cta.header')}</Text>

        <Text>
          {currentStoreName
            ? t('store_name.cta.subtitle', { storeName: currentStoreName })
            : t('store_name.cta.subtitle_placeholder')}
        </Text>
        <Button
          disabled={!currentStoreName}
          onClick={launchStore}
          size="large"
          fullWidth
          suffixIcon={<ChevronRight />}
        >
          {t('LAUNCH_YOUR_STORE')}
        </Button>
      </CardLayout>
    </Box>
  );
}
